
import { Component, Prop, Vue } from 'vue-property-decorator'
import AnswerFormula from '@/components/molecules/AnswerFormula.vue'
import KatexMixedText from '@/components/molecules/KatexMixedText.vue'
import ButtonInput from '@/components/organisms/study/ButtonInput.vue'
import { StudyModel } from '@/models/StudyModel'
import { DrawingModel } from '@/models/DrawingModel'

/**
 * 数式入力イベント発生時の処理型
 */
export type InputNumericalFormulaFunction = (
  question: StudyModel.Question,
  index: number,
  afterFunction: StudyModel.AfterInputNumericalFormulaFunction
) => void

/**
 * 設問情報の解答欄表示(数式)
 */
@Component({
  components: {
    AnswerFormula,
    KatexMixedText,
    ButtonInput,
  },
})
export default class InputNumericalFormula extends Vue {
  /** 設問情報 */
  @Prop()
  private question!: StudyModel.Question

  /** 数式入力時の処理 */
  @Prop()
  private inputNumericalFormula!: InputNumericalFormulaFunction

  /** アクティブな入力欄のインデックス */
  private activeIndex: number = 0

  /** 入力値の更新タイムスタンプ(DOMを更新させるために使う) */
  private updatedAt: number = 0

  /**
   * 表示用要素の取得
   *
   * @returns 入力式の表示用要素(配列)
   */
  private get items(): StudyModel.FrontValueInput[] {
    return this.question.contents.map((content) => {
      return content.frontValues as StudyModel.FrontValueInput
    })
  }

  /**
   * 入力イベント
   *
   * @param index 入力欄のインデックス
   */
  private input(index: number): void {
    this.activeIndex = index
    this.inputNumericalFormula(this.question, index, this.afterFunction)
  }

  /**
   * 入力後の処理
   *
   * @param value 入力値
   * @param inputType 入力モード
   * @param strokes ストローク情報
   */
  private afterFunction(value: string, inputType: string, strokes: DrawingModel.Stroke[]): void {
    // 値の更新
    this.question.inputValues[this.activeIndex] = value
    const questionContent = this.question.contents[this.activeIndex] as StudyModel.ContentNumericalFormula
    questionContent.inputType = inputType
    questionContent.strokes.splice(0)
    questionContent.strokes.push(...strokes)
    // DOM更新のためキー値を書き換え
    this.updatedAt = new Date().valueOf()
  }
}
